<template>
  <div>
    <h1>Referrer month</h1>
    <v-card>
      <v-card-text>
        <v-select
          label="Referrer"
          v-model="referrerid"
          :items="referrers"
          item-value="id"
          item-text="name"
          outline
        />
        <DateDropdown v-model="date" />
        <v-btn @click="updateReferrer">Load</v-btn>
      </v-card-text>
    </v-card>
    <v-btn @click="downloadCsv" v-if="referrerMonths">Download csv</v-btn>
    <!-- <h:commandLink value="#{msg.referrerMonth2}">
      <p:dataExporter type="csv" target="tbl" fileName="#{referrerMonthBean.fileName}" />
    </h:commandLink>-->
    <v-data-table
      :headers="headers"
      :items="referrerMonths"
      hide-actions
      class="elevation-1"
      v-if="referrerMonths"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{props.item.instructed | formatDate}}</td>
          <td>{{props.item.totem}}</td>
          <td>{{props.item.nbmId}}</td>
          <td>{{props.item.reference}}</td>
          <td>{{props.item.subBuilding}}</td>
          <td>{{props.item.buildingName}}</td>
          <td>{{props.item.primaryStreet}}</td>
          <td>{{props.item.secondaryStreet}}</td>
          <td>{{props.item.doubleDependentLocality}}</td>
          <td>{{props.item.dependentLocality}}</td>
          <td>{{props.item.postTown}}</td>
          <td>{{props.item.county}}</td>
          <td>{{props.item.postCode}}</td>
          <td>{{props.item.poBox}}</td>
          <td>{{props.item.propertyPrice}}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { parse } from "json2csv";
import DateDropdown from "@/components/date/DateDropdown";
import nbmlaw from "@/api/nbmlaw";
import { download } from "@/util/helpers";
export default {
  name: "ReferrerMonth",
  metaInfo() {
    return {
      title: "Referrer month",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    DateDropdown
  },
  data() {
    return {
      referrers: null,
      referrerid: null,
      date: new Date().toISOString().substr(0, 10),
      referrerMonths: null,
      headers: [
        {
          text: "Instructed",
          value: "instructed"
        },
        {
          text: "Totem",
          value: "totem"
        },
        {
          text: "Nbm id",
          value: "nbmId"
        },
        {
          text: "Reference",
          value: "reference"
        },
        {
          text: "Sub building",
          value: "subBuilding"
        },
        {
          text: "Building name",
          value: "buildingName"
        },
        {
          text: "Primary street",
          value: "primaryStreet"
        },
        {
          text: "Secondary street",
          value: "secondaryStreet"
        },
        {
          text: "Double dependent locality",
          value: "doubleDependentLocality"
        },
        {
          text: "Dependent locality",
          value: "dependentLocality"
        },
        {
          text: "Post town",
          value: "postTown"
        },
        {
          text: "County",
          value: "county"
        },
        {
          text: "Postcode",
          value: "postCode"
        },
        {
          text: "PO box",
          value: "poBox"
        },
        {
          text: "Property pirce",
          value: "propertyPrice"
        }
      ]
    };
  },
  methods: {
    fetchReferrers() {
      nbmlaw
        .get(`/cors/admin/directory/types/13/entities`)
        .then(response => {
          // console.log(response.data);
          this.referrers = response.data;
        })
        .catch(() => {});
    },
    updateReferrer() {
      if (this.referrerid) {
        this.fetchReferrerMonths();
      }
    },
    fetchReferrerMonths() {
      const date = new Date(this.date);
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      nbmlaw
        .get(`/cors/admin/directory/entities/${this.referrerid}/leads`, {
          params: { month, year }
        })
        .then(response => {
          // console.log(response.data);
          this.referrerMonths = response.data;
        })
        .catch(() => {});
    },
    downloadCsv() {
      const fields = [
        "instructed",
        "totem",
        "nbmId",
        "reference",
        "subBuilding",
        "buildingName",
        "primaryStreet",
        "secondaryStreet",
        "doubleDependentLocality",
        "dependentLocality",
        "postTown",
        "county",
        "postCode",
        "poBox",
        "propertyPrice"
      ];
      const opts = { fields };
      try {
        const csv = parse(this.referrerMonths, opts);
        // console.log(csv);
        download("referrerMonth.csv", csv);
      } catch (err) {
        // console.error(err);
      }
    }
  },
  created() {
    this.fetchReferrers();
  }
};
</script>